import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

import { LayoutService } from './_layout/services/app.layout.service';
import { VersionCheckerService } from './_shared/services/version-checker.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, ToastModule, SharedModule, ConfirmDialogModule, CommonModule],
  template: `
    <p-confirmDialog />
    <p-toast />
    <router-outlet />
  `,
})
export class AppComponent implements OnInit {
  platformId = inject(PLATFORM_ID);

  constructor(
    private versionCheckerService: VersionCheckerService,
    private layoutService: LayoutService
  ) {
    this.versionCheckerService.checkForUpdate();
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.layoutService.initPreset();
    }
  }
}
